module.exports = __webpack_public_path__ + "static/IMG_4840-a1c184af2c73cdf3c22836c81667c6ea.png";